export enum LOCAL_STORAGE {
  OFFERS_FILTERS = 'offersFilters',
  AMBASSADOR_MERCHANT_OFFERS_FILTERS = 'ambassadorMerchantOffersFilters',
  AMBASSADOR_BRANDS_OFFERS_FILTERS = 'ambassadorBrandsOffersFilters',
  MERCHANT_MY_OFFERS_FILTERS = 'merchantMyOffersFilters',
  MERCHANT_PUBLIC_OFFERS_FILTERS = 'merchantPublicOffersFilters',
  MERCHANT_LOCATION_OFFERS_FILTERS = 'merchantLocationOffersFilters',
  NOTIFICATIONS_OFFERS_FILTERS = 'notificationsOffersFilters',
  NOTIFICATIONS_BRANDS_FILTERS = 'notificationsBrandsFilters',
  NOTIFICATIONS_LINK_LOCATIONS_FILTERS = 'notificationsLinkLocationsFilters',
  NOTIFICATIONS_ORGANIZATIONS_FILTERS = 'notificationsOrganizationsFilters',
  TOKEN_EXPIRES_AT = 'id_token_expires_at',
  TOKEN_STORED_AT = 'id_token_stored_at',
  LOCATIONS_FILTERS = 'locationsFilters',
  CONFIGURATION_LOCATIONS_FILTERS = 'configurationLocationsFilters',
  CONFIGURATION_AMBASSADOR_LOCATIONS_FILTERS = 'configurationAmbassadorLocationsFilters',

  CONFIGURATION_OFFER_CATEGORIES_FILTERS = 'configurationOfferCategoriesFilters',
  CONFIGURATION_AUDIENCES_FILTERS = 'configurationAudiencesFilters',
  CUSTOMERS_FILTERS = 'customersFilters',
  PROMO_CUSTOMERS_FILTERS = 'promoCustomersFilters',
  MANAGE_USERS_FILTERS = 'manageUsersFilters',
  EVENTS_FILTERS = 'eventsFilters',
  CAMPAIGNS_FILTERS = 'campaignsFilters',
  CAMPAIGN_LANDING_PREVIEW_DRAFT = 'campaignLandingPreviewDraft',
  BRANDS_FILTERS = 'brandsFilters',
  CUSTOMER_EVENTS_FILTERS = 'customerEventsFilters',
  VENDORS_CONFIGURATION_FILTERS = 'vendorsConfigurationFilters',
  AMBASSADORS_CONFIGURATION_FILTERS = 'ambassadorsConfigurationFilters',
  AMBASSADOR_CODES_CONFIGURATION_FILTERS = 'ambassadorCodesConfigurationFilters',
  AMBASSADORS_ORGANIZATIONS_CONFIGURATION_FILTERS = 'ambassadorsOrganizationsConfigurationFilters',
  DASHBOARD_EVENTS_STATISTICS_FILTERS = 'dashboardEventsStatisticsFilters',
  ORGANIZATION_DASHBOARD_STATISTICS_FILTERS = 'organizationDashboardStatisticsFilters',
  CONFIGURATION_BRANDS_FILTERS = 'configurationBrandsFilters',
  CONFIGURATION_MARKETS_FILTERS = 'configurationMarketsFilters',

  AUTH_RETURN_URL = 'auth_return_url',
  AUTH_STARTED_AT = 'auth_started_at',

  LINKABLE_LOCATIONS_FILTERS = 'linkableLocationsFilters',
  CREATE_LOCATIONS_FILTERS = 'createLocationsFilters',
  EDIT_LOCATIONS_FILTERS = 'editLocationsFilters',
  ADMIN_LINKABLE_LOCATIONS_FILTERS = 'adminLinkableLocationsFilters',
  ADMIN_CREATE_LOCATIONS_FILTERS = 'adminCreateLocationsFilters',
  ADMIN_EDIT_LOCATIONS_FILTERS = 'adminEditLocationsFilters',
  EDIT_BRAND_REQUEST_FILTERS = 'editBrandRequestFilters',
  ADMIN_EDIT_BRAND_REQUEST_FILTERS = 'adminEditBrandRequestFilters',
  MARKETS_FILTERS = 'marketsFilters',
  ADMIN_MARKETS_FILTERS = 'adminMarketsFilters',
  MARKET_MANAGEMENT_FILTERS = 'marketManagementFilters',
}
